import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { UserRegistrationEntity, UserRegistrationForCreationDto, UserRegistrationResponseDto } from '../types/userregistration.type';
import { ENV } from '@app/constants/env';

export interface ApiResponse<T> {
  success: boolean;
  message?: string;
  data?: T;
  error?: string;
}

export const userRegistrationApi = createApi({
  reducerPath: 'userRegistrationApi',
  baseQuery: fetchBaseQuery({ 
    baseUrl: `${ENV.BASE_API_URL +ENV.USER_APIURL}`,
    prepareHeaders: (headers) => {
      headers.set('Content-Type', 'application/json');
      headers.set('accept', '*/*');
      // Registration is a public endpoint - no auth required
      return headers;
    },
  }),
  tagTypes: ['UserRegistration'],
  endpoints: (builder) => ({
    createRegisterUser: builder.mutation<UserRegistrationResponseDto, UserRegistrationForCreationDto>({
      query: (userData) => {
        return {
          url: '/UserRegistration/CreateRegisterUserData',
          method: 'POST',
          body: userData,
        };
      },
      invalidatesTags: ['UserRegistration'],
      transformResponse: (response: any) => {
        // Handle the response from the stored procedure
        if (Array.isArray(response) && response.length > 0) {
          return response[0];
        }
        return response;
      },
      transformErrorResponse: (response: any) => {
        // Handle different types of errors
        if (response.status === 401) {
          return {
            status: 401,
            message: 'This endpoint requires authentication. Please contact administrator.',
            data: response.data || 'Unauthorized access'
          };
        }
        if (response.status >= 500) {
          return {
            status: response.status,
            message: 'Server error occurred. Please try again later.',
            data: response.data
          };
        }
        return {
          status: response.status || 'UNKNOWN_ERROR',
          message: response.data?.message || 'Registration failed. Please try again.',
          data: response.data
        };
      },
    }),
    
   
  }),
});

export const {
  useCreateRegisterUserMutation,
} = userRegistrationApi;
